import { PaymentPackageState } from "shared/api/services";

export const createStateIdMap = (states: PaymentPackageState[]): Record<string, number> => {
  return states.reduce((map, state) => {
    map[state.name] = state.id;
    return map;
  }, {} as Record<string, number>);
};

export const getStateId = (
  stateName: string,
  dynamicStateMap: Record<string, number>
): number | string => {
  return dynamicStateMap[stateName] || "";
};
